import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center text-muted"
            >
                Loading…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (roles && roles.length && !roles.includes(user.role)) {
        return (
            <div
                data-testid="forbidden-screen"
                className="min-h-screen flex flex-col items-center justify-center gap-3 page-shell"
            >
                <h1 className="h2">Restricted area</h1>
                <p className="text-muted">
                    Your role ({user.role}) does not have access to this page.
                </p>
            </div>
        );
    }
    return children;
}
